import React, { useState } from 'react';
import './FaqSection.css';

const faqs = [
    {
        question: "What types of physiotherapy equipment do you manufacture?",
        answer: "We manufacture a wide range of equipment including traction tables, drop tables, unweighing systems, tilt tables, and more."
    },
    {
        question: "Are your products suitable for hospitals and clinics?",
        answer: "Yes, our equipment is specifically designed to meet the rigorous demands of both clinical environments and large-scale hospitals."
    },
    {
        question: "Do you provide custom equipment sizes?",
        answer: "Yes, we offer customization options for certain models to fit the specific spatial and therapeutic needs of your facility."
    },
    {
        question: "What materials are used in your equipment?",
        answer: "We use high-grade steel and metal alloys for the frames to ensure maximum stability and durability, along with premium rexine upholstery for patient comfort."
    },
    {
        question: "Do your tables have adjustable height systems?",
        answer: "Most of our advanced therapy tables, including the Hi-Low tilt tables, come equipped with smooth motorized height and tilt adjustment mechanisms."
    },
    {
        question: "Do you provide installation or product support?",
        answer: "Yes, we provide comprehensive installation guidance and ongoing product support to ensure your equipment functions perfectly for years to come."
    }
];

const FaqSection = () => {
    const [openIndex, setOpenIndex] = useState(null);

    const toggleFaq = (index) => {
        setOpenIndex(openIndex === index ? null : index);
    };

    return (
        <section className="faq-section">
            <div className="faq-container">
                <div className="faq-left">
                    <span className="section-subtitle">FREQUENTLY ASKED QUESTIONS</span>
                    <h2 className="faq-main-title">
                        Clear Answers About<br />
                        Our Physiotherapy<br />
                        Equipment
                    </h2>

                    <div className="faq-image">
                        <img
                            src="https://primerehabindustries.in/Image/About/Faq.png"
                            alt="Physiotherapy Room"
                        />
                    </div>
                </div>

                <div className="faq-right">
                    <div className="faq-accordion">
                        {faqs.map((faq, index) => (
                            <div
                                className={`faq-item ${openIndex === index ? 'active' : ''}`}
                                key={index}
                                onClick={() => toggleFaq(index)}
                            >
                                <div className="faq-question">
                                    <h3>{faq.question}</h3>
                                    <span className="faq-icon">
                                        {openIndex === index ? (
                                            <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                                                <polyline points="6 9 12 15 18 9"></polyline>
                                            </svg>
                                        ) : (
                                            <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                                                <polyline points="9 18 15 12 9 6"></polyline>
                                            </svg>
                                        )}
                                    </span>
                                </div>

                                {openIndex === index && (
                                    <div className="faq-answer">
                                        <p>{faq.answer}</p>
                                    </div>
                                )}
                            </div>
                        ))}
                    </div>
                </div>
            </div>
        </section>
    );
};

export default FaqSection;
